function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleWorkspaceFeatures2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 858 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0.56,
    width: 858,
    height: 718.87,
    style: {
      fill: "#eff1f2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 705.78,
    cy: 226.33,
    r: 66.98,
    style: {
      fill: "#ffb400"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.35,
    y: 258.11,
    width: 164.35,
    height: 283.35,
    rx: 32.37,
    ry: 32.37,
    style: {
      fill: "#d8dade"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.41,
    y: 236.74,
    width: 245.17,
    height: 283.35,
    rx: 58.95,
    ry: 58.95,
    style: {
      fill: "none",
      stroke: "#00ab31",
      strokeMiterlimit: 10,
      strokeWidth: "4.6px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 578.98,
    y: 411.11,
    width: 63.76,
    height: 186.51,
    rx: 24.39,
    ry: 24.39,
    transform: "translate(1115.23 -106.49) rotate(90)",
    style: {
      fill: "none",
      stroke: "#d8dade",
      strokeMiterlimit: 10,
      strokeWidth: "4.64px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.86,
    y: 525.92,
    width: 27.94,
    height: 27.94,
    rx: 5,
    ry: 5,
    style: {
      fill: "#0581ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.96,
    y: 62.82,
    width: 27.94,
    height: 27.94,
    rx: 13.97,
    ry: 13.97,
    style: {
      fill: "#00ab31"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.78,388.1l-9.4,18.81c-1.7,3.39.77,7.39,4.57,7.39h18.81c3.79,0,6.26-3.99,4.57-7.39l-9.4-18.81c-1.88-3.76-7.25-3.76-9.13,0Z",
    style: {
      fill: "#ee4936"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.86,
    y: 125.91,
    width: 112.24,
    height: 112.24,
    rx: 27.6,
    ry: 27.6,
    style: {
      fill: "none",
      stroke: "#ee4936",
      strokeMiterlimit: 10,
      strokeWidth: "4.64px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.17,
    y: 446.4,
    width: 309.66,
    height: 186.35,
    rx: 15.7,
    ry: 15.7,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.22,562.2h-65.82l22.63,22.63h20.57l22.63-22.63Z",
    style: {
      fill: "#00ab31"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.59,494.32v41.89l22.63-19.27-22.63-22.63Z",
    style: {
      fill: "#ee4936"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.59,516.95v45.25l22.63,13.22v-58.47h-22.63Z",
    style: {
      fill: "#0581ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.57,494.32c-3.41,0-6.17,2.76-6.17,6.17v61.71l22.63,21.23v-66.48h20.57v-22.63h-37.02Z",
    style: {
      fill: "#ffb400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.02,562.2h-22.63v16.45c0,3.41,2.76,6.17,6.17,6.17h16.45v-22.63Z",
    style: {
      fill: "#008115"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.22,562.2h-22.63v22.63h16.45c3.41,0,6.17-2.76,6.17-6.17v-16.45Z",
    style: {
      fill: "#096adf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.81,539.57l10.72,12.26,14.42,9.21,2.51-21.39-2.51-20.92-14.69,8.09-10.45,12.75Z",
    style: {
      fill: "#008115"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.59,559.05v18.23c0,4.17,3.37,7.54,7.54,7.54h18.23l3.77-13.78-3.77-11.99-12.51-3.77-13.26,3.77Z",
    style: {
      fill: "#096adf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.36,494.32l-25.77,25.77,13.26,3.77,12.51-3.77,3.71-11.83-3.71-13.94Z",
    style: {
      fill: "#ee4936"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.36,520.09h-25.77v38.97h25.77v-38.97Z",
    style: {
      fill: "#0581ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.42,505.23l-16.47,13.5v42.31l16.54,13.56c2.48,1.94,6.1.17,6.1-2.98v-63.48c0-3.19-3.7-4.93-6.17-2.92Zm-41.61,34.34v19.48h-36.45v25.77h54.05c4.17,0,7.54-3.37,7.54-7.54v-16.24l-25.14-21.47Z",
    style: {
      fill: "#00ab31"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.41,494.32h-54.05v25.77h36.45v19.48l25.14-20.83v-16.88c0-4.17-3.37-7.54-7.54-7.54Z",
    style: {
      fill: "#ffb400"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.58,
    y: 460.28,
    width: 282.82,
    height: 158.57,
    rx: 4.84,
    ry: 4.84,
    style: {
      fill: "none",
      stroke: "#d8dade",
      strokeMiterlimit: 10,
      strokeWidth: "2.61px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.43,
    y: 87.25,
    width: 146.55,
    height: 265.02,
    rx: 20.51,
    ry: 20.51,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.19,243.61h11.24v-27.31l-16.06-12.05v34.54c0,2.67,2.16,4.82,4.82,4.82",
    style: {
      fill: "#0581ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.98,243.61h11.24c2.67,0,4.82-2.16,4.82-4.82v-34.54l-16.06,12.05",
    style: {
      fill: "#00ab31"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.98,195.42v20.88l16.06-12.05v-6.43c0-5.96-6.8-9.36-11.57-5.78l-4.5,3.37Z",
    style: {
      fill: "#ffb400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.43,216.3v-20.88l19.28,14.46,19.28-14.46v20.88l-19.28,14.46",
    style: {
      fill: "#ee4936"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.37,197.83v6.43l16.06,12.05v-20.88l-4.5-3.37c-4.77-3.57-11.57-.18-11.57,5.78",
    style: {
      fill: "#ed1b08"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.14,
    y: 97.51,
    width: 125.15,
    height: 244.52,
    rx: 10.12,
    ry: 10.12,
    style: {
      fill: "none",
      stroke: "#d8dade",
      strokeMiterlimit: 10,
      strokeWidth: "3.57px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.04,143.06h333.7c11.76,0,21.31,9.55,21.31,21.31v216.65h-376.31v-216.65c0-11.76,9.55-21.31,21.31-21.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.61,160.94h328.54c3.55,0,6.42,2.88,6.42,6.42v195.77h-341.39v-195.77c0-3.55,2.88-6.42,6.42-6.42Z",
    style: {
      fill: "none",
      stroke: "#d8dade",
      strokeMiterlimit: 10,
      strokeWidth: "3.57px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m603.56,228.64l-27.91-12.6c-1.73,1.02-3.2,2.43-4.22,4.22l-32.52,56.33c-1.01,1.75-1.53,3.74-1.54,5.76l25.08,17.55,41.11-71.27Z",
    style: {
      fill: "#00ab31"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m631.53,282.35h-76.55v30.47c1.73,1.02,3.71,1.54,5.76,1.54h65.03c2.05,0,4.03-.58,5.76-1.54v-30.47Z",
    style: {
      fill: "#0581ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m631.34,248.43l-16.26-28.16c-1.02-1.79-2.5-3.2-4.22-4.22l-23.94,19.49,38.65,67.01,23.5-20.18c0-1.98-.51-3.97-1.54-5.76l-16.19-28.16Z",
    style: {
      fill: "#ffb400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m545.83,300.08l4.93,8.51c1.02,1.79,2.5,3.2,4.22,4.22l17.6-30.47h-35.2c0,1.98.51,3.97,1.54,5.76l6.91,11.97Z",
    style: {
      fill: "#096adf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m631.54,312.82c1.73-1.02,3.2-2.43,4.22-4.22l2.05-3.52,9.79-16.96c1.02-1.79,1.54-3.78,1.54-5.76h-35.21l17.6,30.47Z",
    style: {
      fill: "#ee4936"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m593.26,246.51l17.6-30.47c-1.73-1.02-3.71-1.54-5.76-1.54h-23.68c-2.05,0-4.03.58-5.76,1.54l17.6,30.47Z",
    style: {
      fill: "#008115"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.84,238.15l-23.65-2.63-28.91,2.63-2.63,26.28,2.63,26.28,26.28,3.28,26.28-3.28,2.63-26.93-2.63-25.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.06,278.92c-1.96-1.33-3.32-3.26-4.07-5.83l4.56-1.88c.41,1.58,1.14,2.8,2.17,3.67,1.02.87,2.27,1.29,3.73,1.29s2.77-.45,3.84-1.36c1.07-.91,1.61-2.06,1.61-3.46s-.57-2.6-1.7-3.51c-1.13-.91-2.55-1.36-4.24-1.36h-2.63v-4.51h2.36c1.46,0,2.69-.39,3.69-1.18,1-.79,1.5-1.87,1.5-3.24,0-1.22-.45-2.19-1.34-2.92s-2.02-1.1-3.4-1.1-2.4.35-3.19,1.07-1.36,1.6-1.72,2.63l-4.51-1.88c.6-1.7,1.7-3.19,3.3-4.49,1.61-1.29,3.67-1.94,6.16-1.94,1.85,0,3.51.35,4.98,1.07,1.47.72,2.63,1.71,3.46,2.97.83,1.27,1.25,2.69,1.25,4.26s-.39,2.97-1.16,4.09-1.73,1.97-2.86,2.57v.27c1.49.62,2.71,1.58,3.67,2.86.95,1.28,1.43,2.81,1.43,4.6s-.45,3.38-1.36,4.78-2.16,2.5-3.75,3.3c-1.6.8-3.39,1.21-5.38,1.21-2.31,0-4.43-.66-6.4-1.98Z",
    style: {
      fill: "#096adf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m441.04,256.3l-4.98,3.62-2.5-3.8,8.98-6.48h3.44v30.55h-4.94v-23.9Z",
    style: {
      fill: "#096adf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.84,314.36l23.65-23.65-11.82-5.26-11.82,5.26-5.26,11.82,5.26,11.82Z",
    style: {
      fill: "#e1563f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.03,302.53l5.26,11.82h52.55v-23.65h-52.55l-5.26,11.82Z",
    style: {
      fill: "#00ab31"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386.51,214.5c-4.36,0-7.88,3.53-7.88,7.88v68.32l11.82,5.26,11.82-5.26v-52.55h52.55l5.26-11.82-5.25-11.82h-68.32Z",
    style: {
      fill: "#0581ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.63,290.71v15.77c0,4.36,3.53,7.88,7.88,7.88h15.77v-23.65h-23.65Z",
    style: {
      fill: "#008115"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.84,238.15v52.55h23.65v-52.55l-11.82-5.26-11.82,5.26Z",
    style: {
      fill: "#ffb400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.49,238.15v-15.77c0-4.36-3.53-7.88-7.88-7.88h-15.77v23.65h23.65Z",
    style: {
      fill: "#096adf"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.2,
    y: 381.01,
    width: 471.37,
    height: 14.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 325.73,
    y1: 379.21,
    x2: 702.04,
    y2: 379.21,
    style: {
      fill: "none",
      stroke: "#d8dade",
      strokeMiterlimit: 10,
      strokeWidth: "3.57px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleWorkspaceFeatures2);
export default __webpack_public_path__ + "static/media/google-workspace-features-2.adb987aac2ddf1d836ed4d1b78fef2d6.svg";
export { ForwardRef as ReactComponent };